<div
  *ngIf="dataSource !== undefined"
  id="tabs6"
  class="data-grid-demo"
  [ngStyle]="{ height: height }"
>
  <div
    id="data-grid-demo"
    class="data-grid-demo"
    [ngStyle]="{ height: height ? height :'calc(var(--dk-vh, 100vh) - 155px)' }"
    style="display: flex; flex-direction: column;overflow: hidden; position: relative;"
  >
    <div class="grid-lock-overlay" *ngIf="gridLocked"></div>
    <dx-data-grid [visible]="!pivotGridMode"
                  [ngClass]="{
                    'grid-class2': heightAnimation === 'shirink',
                    'grid-class3': heightAnimation === 'expand',
                    'grid-class': heightAnimation === undefined || heightAnimation !== 'shirink' && heightAnimation !== 'expand',
                    'wrap-header': gridCtlList.multilineHeaderYn,
                    'dk-form-edit-mode': gridCtlList.editMode === 'form'
                  }"
                  style="flex: 1; max-width: fit-content; overflow: auto;"
                  [id]="gridIdRandom"
                  [disabled]="gridDisabled"
                  (onInitNewRow)="onInitNewRow($event)"
                  [dataSource]="dataSource"
                  [showBorders]="showBorders"
                  [focusedRowEnabled]="focusedRowEnabled"
                  [columnHidingEnabled]="columnHidingEnabled"
                  [columnResizingMode]="'widget'"
                  [columnAutoWidth]="true"
                  [wordWrapEnabled]="gridCtlList.lineCount > 1"
                  [width]="width"
                  [style.max-width]="'fit-content'"
                  [height]="height ? height : '100%'"
                  [style]="style"
                  [allowColumnReordering]="true"
                  [rowAlternationEnabled]="rowAlternationEnabled"
                  [allowColumnResizing]="true"
                  [keyExpr]="keyExpr"
                  [noDataText]="((dataSource == null)&& !customNoDataText) ? noDataSourceText :customNoDataText?customNoDataText: noDataText"
                  [filterValue]="filterValue ? filterValue : null"
                  (onContextMenuPreparing)="contextMenuRightClick($event)"
                  (onRowClick)="getSelectedRow($event)"
                  (onRowDblClick)="getOnRowDblClick($event)"
                  (onExporting)="onExporting($event)"
                  [remoteOperations]="{
                    groupPaging: true,
                    paging: true,
                    filtering: true,
                    sorting: true,
                    summary: true,
                    grouping: true
                  }"

                  [scrolling]="{ mode: gridCtlList.pageCount === 0?'virtual':scrollingMode, rowRenderingMode: gridCtlList.pageCount === 0?'virtual':'standard', preloadEnabled: true }"
                  [(selectedRowKeys)]="selectedRowKeys"
                  (focusedRowIndexChange)="focusedRowIndexChange($event)"
                  (onFocusedRowChanged)="onFocusedRowChangedFunc($event)"
                  [focusedRowIndex]="focusedRowIndex"
                  [focusedRowKey]="focusedRowKey"
                  (onSelectionChanged)="selectionChangedHandler($event)"
                  [syncLookupFilterValues]="false"
                  [hoverStateEnabled]="true"
                  (filterValueChange)="logSelectedFilter($event)"
                  (onSaved)="onSaved($event)"
                  (onEditorPreparing)="onEditorPreparing($event)"
                  (onRowPrepared)="onRowPrepared($event)"
                  (onCellPrepared)="onCellPrepared($event)"
                  (onKeyDown)="onKeyDown($event)"
                  (onDataErrorOccurred)="onDataErrorOccurred($event)"
                  [repaintChangesOnly]="true"
                  (onOptionChanged)="onOptionChangedFunc($event)"
                  (onRowUpdating)="onRowUpdatingFunc($event)"
                  (onRowRemoving)="onRowRemovingFunc($event)"
                  (onRowInserting)="onRowInsertingFunc($event)"
                  (onRowValidating)="onRowValidatingFunc($event)"
                  [errorRowEnabled]="errorRowEnabled"
                  (onContentReady)="contentReady($event)"
                  (onFocusedCellChanged)="onFocusedCellChangedFunc($event)"
                  (onFocusedRowChanging)="onFocusedRowChangingFunc($event)"
                  (selectedRowKeysChange)="onselectedRowKeysChange($event)"
                  [autoNavigateToFocusedRow]="gridAutoNavigateToFocusedRow"
                  (onFocusedCellChanging)="onFocusedCellChangingFunc($event)"
                  (onEditingStart)="onEditingStart($event)"
                  (onInitialized)="onGridInit($event)"
                  [dateSerializationFormat]="'yyyy-MM-ddTHH:mm:ss'"
                  (onRowInserted)="onRowInsertedFunc($event)"
    >
      <dxo-keyboard-navigation
        [editOnKeyPress]="false"
        [enterKeyAction]="'moveFocus'"
        [enterKeyDirection]="'column'"
      >
      </dxo-keyboard-navigation>
      <dxo-row-dragging
        [allowReordering]="isDragging"
        [onReorder]="onReorder"
        [showDragIcons]="true"
        dropFeedbackMode="push"
      ></dxo-row-dragging>
      <dxo-sorting mode="multiple"></dxo-sorting>
      <ng-container *ngIf="!this.baseTable" id="tabs7">
        <ng-container *ngIf="gridCtlList.allowExportxlsYn">
          <dxo-export
            [enabled]="gridCtlList.allowExportxlsYn && !!formMetaData?.formYetki?.exportYn"
            [formats]="['xlsx']"
            [allowExportSelectedData]="gridCtlList.showSelectionYn"
          ></dxo-export>
        </ng-container>

        <ng-container *ngIf="gridCtlList.allowExportpdfYn">
          <dxo-export
            [enabled]="gridCtlList.allowExportpdfYn && !!formMetaData?.formYetki?.exportYn"
            [formats]="['pdf']"
            [allowExportSelectedData]="gridCtlList.showSelectionYn"
          ></dxo-export>
        </ng-container>
        <ng-container
          *ngIf="gridCtlList.allowExportxlsYn && gridCtlList?.allowExportpdfYn"
        >
          <dxo-export
            [enabled]="gridCtlList.allowExportxlsYn && !!formMetaData?.formYetki?.exportYn"
            [formats]="['xlsx', 'pdf']"
            [allowExportSelectedData]="gridCtlList.showSelectionYn"
          ></dxo-export>
        </ng-container>
        <ng-container>
          <dxo-selection
            *ngIf="gridCtlList.showSelectionYn && gridCtlList.allowSelectionYn && manuelSelectionManage"
            [selectAllMode]="allMode"
            [showCheckBoxesMode]="checkBoxesMode"
            mode="multiple"
          ></dxo-selection>
        </ng-container>

        <dxo-filter-panel *ngIf="false" [visible]="true"></dxo-filter-panel>
        <!-- <dxo-state-storing
          [enabled]="gridCtlList.alloeStateYn"
          type="localStorage"
          storageKey="storage"
        ></dxo-state-storing> -->
        <dxo-paging
          [enabled]="gridCtlList.pageCount === 0?false:gridCtlList.allowPagingYn"
          [pageSize]="gridCtlList.pageCount === 0?50:gridCtlList.pageCount"
        ></dxo-paging>
        <dxo-column-chooser
          #columnChooser
          title="Kolon Seçiniz"
          [enabled]="
            gridCtlList.columnChooserYn && gridCtlList.showActioncolumnYn
          "
          [mode]="columnChooserModes[1].key"
          [id]="'columnChooser_' + gridIdRandom"
          [container]="'#' + gridIdRandom"
        >
          <dxo-position
            my="right top"
            at="right top"
            [of]="'#' + gridIdRandom"
          ></dxo-position>

          <dxo-search
            [enabled]="searchEnabled"
            [editorOptions]="editorOptions"
          ></dxo-search>

          <dxo-selection
            [allowSelectAll]="allowSelectAll"
            [selectByClick]="selectByClick"
            [recursive]="recursive"
          ></dxo-selection>
        </dxo-column-chooser>
        <!--        *ngIf="gridCtlList.editMode === 'batch' || 'cell' || 'row' || 'form' || 'popup' || 'customForm' || 'customPopup'"-->
        <div *ngIf="columnTransactions">
          <!-- GenControlForm popup edit eski hâli: koşullar sadece 'row' için yetki veriyordu
            [allowUpdating]="(editingMode || gridCtlList.editMode) === 'row' ? ... : batchEditingActive && donemAktif"
            [allowAdding]="(editingMode || gridCtlList.editMode) === 'row' ? ... : false"
            [allowDeleting]="(editingMode || gridCtlList.editMode) === 'row' ? ... : batchEditingActive && donemAktif "
            [confirmDelete]="(editingMode || gridCtlList.editMode) === 'row' ? confirmDelete : false"
          -->
          <!-- DList 'row' iken ekran [editingMode]="'popup'" verirse aynı yetkilerle popup edit açılır -->
          <dxo-editing
            *ngIf="gridCtlList.editMode === 'row'"
            [mode]="editingMode?editingMode:gridCtlList.editMode"
            [useIcons]="true"
            [allowUpdating]="rowVeyaPopupEdit ? gridCtlList.allowUpdatingYn && formMetaData?.formYetki?.updateYn && donemAktif : batchEditingActive && donemAktif"
            [allowAdding]="rowVeyaPopupEdit ? gridCtlList.allowAddingYn && formMetaData?.formYetki?.insertYn && donemAktif && dataSource : false"
            [allowDeleting]="rowVeyaPopupEdit ? gridCtlList.allowDeletingYn && formMetaData?.formYetki?.deleteYn && donemAktif: batchEditingActive && donemAktif "
            [confirmDelete]="rowVeyaPopupEdit ? confirmDelete : false"
          >
            <dxo-popup
              [title]="popupEditTitle || 'Kayıt Düzenle'"
              [showTitle]="true"
              [width]="popupEditWidth"
              [height]="'auto'"
              [hideOnOutsideClick]="false"
            ></dxo-popup>
          </dxo-editing>

          <!-- editMode === 'form' : satır altında form edit row açılır, içerik editForm template ile override edilir -->
          <dxo-editing
            *ngIf="gridCtlList.editMode === 'form'"
            mode="form"
            [useIcons]="true"
            [allowUpdating]="gridCtlList.allowUpdatingYn && formMetaData?.formYetki?.updateYn && donemAktif"
            [allowAdding]="gridCtlList.allowAddingYn && formMetaData?.formYetki?.insertYn && donemAktif && dataSource"
            [allowDeleting]="false"
            [confirmDelete]="false"
            [texts]="{ editRow: ' ', addRow: ' ', deleteRow: ' ' }"
          >
            <!--
              ÖNEMLİ: editing.mode='form' default olarak kolonlardan otomatik edit form üretir.
              Bunu kırmak için editing.form.items'ı tek bir template item'a düşürüyoruz.
              Bu template içinde dışarıdan gelen Angular editFormTemplate render edilir.
            -->
            <dxo-form [colCount]="1">
              <dxi-item itemType="simple" template="dk_inline_edit_form_host"></dxi-item>
            </dxo-form>
          </dxo-editing>

          <dxo-editing
            *ngIf="gridCtlList.editMode !== 'row' && this.editingMode === 'batch'"
            [useIcons]="true"
            [mode]="this.editingMode"
            [allowUpdating]="batchEditingActive && donemAktif && batchEditingAllowUpdating"
            [allowAdding]="false"
            [allowDeleting]="batchEditingActive && donemAktif && batchEditingAllowDeleting"
            startEditAction="click"
            [selectTextOnEditStart]="true"

          >
          </dxo-editing>

          <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        </div>

        <!-- editMode === 'form' için minimal işlem butonları (edit row'u açar + dışarıya delete event'i verir) -->
        <dxi-column
          *ngIf="gridCtlList.editMode === 'form' && columnTransactions && !showBatchEditButton"
          [caption]="'İşlemler'"
          type="buttons"
          [width]="110"
          [allowFiltering]="false"
          [allowSearch]="false"
        >
          <dxi-button
            icon="edit"
            [hint]="'Düzenle'"
            [disabled]="!(gridCtlList.allowUpdatingYn && formMetaData?.formYetki?.updateYn && donemAktif)"
            [onClick]="clickEditButtonFunc"
          ></dxi-button>
          <!-- DKM-2587 Cedric: eski hâli [disabled]="!(gridCtlList.allowDeletingYn && formMetaData?.formYetki?.deleteYn && donemAktif)"
               silPasif: satirSilinebilirMi verilmezse aynı boolean döner; verilirse satır bazlı pasif. -->
          <dxi-button
            icon="trash"
            [hint]="'Sil'"
            [disabled]="silPasif(!(gridCtlList.allowDeletingYn && formMetaData?.formYetki?.deleteYn && donemAktif))"
            [onClick]="clickDeleteButtonFunc"
          ></dxi-button>
        </dxi-column>

        <!-- editing.form.items içindeki custom item template -->
        <div *dxTemplate="let itemCtx of 'dk_inline_edit_form_host'">
          <!-- DevExtreme form template context farklı şekillerde gelebiliyor; olabildiğince sağlam al -->
          <ng-container *ngIf="
            itemCtx?.component?.option?.('formData') ||
            itemCtx?.formData ||
            itemCtx?.data?.formData ||
            itemCtx?.data
          ">
          <ng-container
            *ngIf="gridCtlList.editMode === 'form' && editFormTemplate"
            [ngTemplateOutlet]="editFormTemplate"
            [ngTemplateOutletContext]="{
              $implicit: (formEditRowData || itemCtx?.component?.option?.('formData') || itemCtx?.formData || itemCtx?.data?.formData || itemCtx?.data || itemCtx),
              ctx: itemCtx,
              data: (formEditRowData || itemCtx?.component?.option?.('formData') || itemCtx?.formData || itemCtx?.data?.formData || itemCtx?.data || itemCtx),
              grid: dataGrid?.instance
            }"
          ></ng-container>
          </ng-container>
        </div>
        <dxi-column
          [caption]="'İşlemler'"
          type="buttons"
          *ngIf="gridCtlList.editMode === 'row' && columnTransactions && !showBatchEditButton"
        >
          <dxi-button
            name="edit"
            [hint]="'Düzenle'"
            [disabled]="
              !(
                gridCtlList.allowUpdatingYn &&
                formMetaData?.formYetki?.updateYn &&
                donemAktif
              )
            "
          ></dxi-button>
          <!-- DKM-2587 Cedric: eski hâli [disabled]="!( gridCtlList.allowDeletingYn && formMetaData?.formYetki?.deleteYn && donemAktif )" -->
          <dxi-button
            name="delete"
            [hint]="'Sil'"
            [disabled]="
              silPasif(!(
                gridCtlList.allowDeletingYn &&
                formMetaData?.formYetki?.deleteYn &&
                donemAktif
              ))
            "
          ></dxi-button>


          <ng-container *ngIf="inlineMenuActions">
            <dxi-button
              [id]="'menuButton' + gridIdRandom"
              [hint]="'İşlemler'"
              icon="menu"
              [onClick]="clickmenuButtonFunc"
            ></dxi-button>
          </ng-container>
          <ng-container *ngIf="otherActionBtnList">
            <dxi-button
              *ngFor="let button of otherActionBtnList"
              [hint]="button.name"
              [text]="button.name"
              [icon]="button.icon"
              [disabled]="button.disabled"
              [onClick]="otherActionClicked.bind(this,{button})"
            >
            </dxi-button>
          </ng-container>
          <ng-container
            *ngIf="!this.inlineMenuActions && gridCtlList.historyEntity"
          >
            <dxi-button
              icon="clock"
              hint="History"
              [hint]="'Geçmiş'"
              [onClick]="clickShowHistoryButtonFunc"
            ></dxi-button>
          </ng-container>
        </dxi-column>
        <!--
          showBatchEditButton=true olan gridlerde İşlemler kolonu tamamen buradan
          üretilir - backend dlist'in columnList'e bastığı 'İşlemler' item'ının
          type'ına (editButtonColumn/deleteButtonColumn/bothDeleteEditButton) veya
          gridCtlList.allowUpdatingYn'e bağlı DEĞİL (bkz. yukarıdaki 'custom'
          bloğunun && !showBatchEditButton koşulu - o blok bu grid için devre dışı,
          çakışan/duplike bir "İşlemler" kolonu oluşmasın diye).
        -->
        <dxi-column
          [caption]="'İşlemler'"
          type="buttons"
          [width]="90"
          [allowFiltering]="false"
          [allowSearch]="false"
          *ngIf="editingMode === 'batch' && batchEditing && showBatchEditButton && columnTransactions"
        >
          <dxi-button
            icon="edit"
            [hint]="'Düzenle'"
            [disabled]="!(formMetaData?.formYetki?.updateYn && donemAktif)"
            [onClick]="clickEditButtonFunc"
          ></dxi-button>
          <!-- DKM-2587 Cedric: eski hâli [disabled]="!(formMetaData?.formYetki?.deleteYn && donemAktif)" -->
          <dxi-button
            icon="trash"
            [hint]="'Sil'"
            [disabled]="silPasif(!(formMetaData?.formYetki?.deleteYn && donemAktif))"
            [onClick]="clickDeleteButtonFunc"
          ></dxi-button>
          <ng-container *ngIf="!inlineMenuActions && gridCtlList.historyEntity">
            <dxi-button
              icon="clock"
              [hint]="'Geçmiş'"
              [onClick]="clickShowHistoryButtonFunc"
            ></dxi-button>
          </ng-container>
        </dxi-column>
        <dxo-grouping [autoExpandAll]="false" [contextMenuEnabled]="true"></dxo-grouping>
        <dxo-group-panel *ngIf="isGroupingYn"
                         [visible]="gridCtlList.allowGroupingYn && gridCtlList.showGroupingYn"
                         #group
        ></dxo-group-panel>
      </ng-container>
      <dxo-filter-row
        [visible]="gridCtlList.allowFilterYn && gridCtlList.showFilterYn"
      ></dxo-filter-row>
      <dxo-pager
        [visible]="gridCtlList.pageCount === 0?false:gridCtlList.allowPagingYn"
        [allowedPageSizes]="allowedPageSizes"
        [displayMode]="displayMode"
        [showPageSizeSelector]="showPageSizeSelector"
        [showInfo]="showInfo"
        [showNavigationButtons]="showNavButtons"
        [infoText]="pagerInfoTextGorunen"
      >
        <!-- DKM-5052 Clara: eski hâli (seçili satır sayısı eklendi)
        [infoText]="pagerInfoText ? pagerInfoText + ' Sayfa {0} / {1} ({2} Veri)' : undefined"
        -->
      </dxo-pager>
      <dxo-search-panel
        [visible]="gridCtlList.allowSearchYn && gridCtlList.showSearchYn"
        (textChange)="searchValueChange($event)"
        [width]="'auto'"
        placeholder="Ara..."
      ></dxo-search-panel>
      <ng-container *ngFor="let item of columnList">
        <ng-container *ngIf="item.type === columnType.genericColumn">
          <dxi-column
            [dataField]="item.dataField"
            [caption]="item.caption"
            [dataType]="getSafeDataType(item.dataType)"
            [width]="item.width"
            [groupIndex]="item.groupIndex"
            [sortIndex]="item.sortIndex"
            [sortOrder]="item.sortOrder"
            [hidingPriority]="item.hidingPriority"
            [visible]="item.visible"
            [visibleIndex]="item.visibleIndex"
            [fixed]="item.fixed"
            [allowExporting]="true"
            [allowFiltering]="item.allowFiltering"
            [allowSearch]="item.allowFiltering && !aramaDisi(item.dataField)"
            [allowGrouping]="item.allowGrouping"
            [allowSorting]="item.allowSorting"
            [allowHiding]="item.allowHiding"
            [allowEditing]="item.allowEditing"
            [format]="item.format"
            [fixedPosition]="getSafeFixedposition(item.fixedPosition)"
            [cellTemplate]="
              cellTemplates ? (cellTemplates | cellTemplate: item.dataField) : (item.viewTemplate ? item.viewTemplate : null)
            "
            [editCellTemplate]="editCellTemplates ? (editCellTemplates | editCellTemplate: item.dataField) : undefined"
            [filterValue]="item.defaultFilter"
            [editorOptions]="{maxLength: item?.dataLength}"
            [setCellValue]="item.setCellValue"
          >
            <ng-container *ngIf="item.options">
              <dxo-form-item
                [colSpan]="item.options[0]?.value"
                [editorType]="item.options[1]?.value"
                [editorOptions]="item.options[2]?.value"
              >
              </dxo-form-item>
            </ng-container>

            <ng-container *ngFor="let val of item.validators">
              <dxi-validation-rule
                [type]="val.type"
                [pattern]="val.pattern"
                [message]="val.mes"
                [max]="val.max"
                [min]="val.min"
              ></dxi-validation-rule>
            </ng-container>
          </dxi-column>
        </ng-container>

        <ng-container *ngIf="item.type === columnType.currencyColumn">
          <dxi-column
            [dataField]="item.dataField"
            [caption]="item.caption"
            [dataType]="'number'"
            [width]="item.width"
            [hidingPriority]="item.hidingPriority"
            [groupIndex]="item.groupIndex"
            [format]="currencyFormat"
            [visibleIndex]="item.visibleIndex"
            [fixed]="item.fixed"
            [fixedPosition]="getSafeFixedposition(item.fixedPosition)"
            [sortIndex]="item.sortIndex"
            [sortOrder]="item.sortOrder"
            [visible]="item.visible"
            [allowExporting]="true"
            [allowFiltering]="item.allowFiltering"
            [allowSearch]="item.allowFiltering && !aramaDisi(item.dataField)"
            [allowGrouping]="item.allowGrouping"
            [allowSorting]="item.allowSorting"
            [allowHiding]="item.allowHiding"
            [allowEditing]="item.allowEditing"
            [filterValue]="item.defaultFilter"
            [cellTemplate]="
              cellTemplates ? (cellTemplates | cellTemplate: item.dataField) : (item.viewTemplate ? item.viewTemplate : null)
            "
            [editCellTemplate]="editCellTemplates | editCellTemplate: item.dataField"
            [editorOptions]="{format: currencyFormat, min: 0}"
            [setCellValue]="item.setCellValue"
          >
            <ng-container *ngFor="let val of item.validators">
              <dxi-validation-rule
                [type]="val.type"
                [pattern]="val.pattern"
                [message]="val.mes"
                [max]="val.max"
                [min]="val.min"
              ></dxi-validation-rule>
            </ng-container>
          </dxi-column>
        </ng-container>
        <ng-container *ngIf="item.type === columnType.lookupColumn">
          <dxi-column
            [dataField]="item.dataField"
            [caption]="item.caption"
            [dataType]="getSafeDataType(item.dataType)"
            [width]="item.width"
            [groupIndex]="item.groupIndex"
            [sortIndex]="item.sortIndex"
            [sortOrder]="item.sortOrder"
            [hidingPriority]="item.hidingPriority"
            [visible]="item.visible"
            [visibleIndex]="item.visibleIndex"
            [fixed]="item.fixed"
            [fixedPosition]="getSafeFixedposition(item.fixedPosition)"
            [allowExporting]="true"
            [allowSorting]="item.allowSorting"
            [allowEditing]="item.allowEditing"
            [cellTemplate]="cellTemplates ? (cellTemplates | cellTemplate: item.dataField) : (item.viewTemplate ? item.viewTemplate : null)"
            [editCellTemplate]="editCellTemplates | editCellTemplate: item.dataField"
            [filterValue]="item.defaultFilter"
          >
            <dxo-lookup
              [dataSource]="getLookupData(item?.lookup)"
              [valueExpr]="item.dataType === 'number' ? 'kod' : 'ozelKod'"
              [displayExpr]="'aciklama'"
              [allowClearing]="true"
            ></dxo-lookup>
            <ng-container *ngFor="let val of item.validators">
              <dxi-validation-rule
                [type]="val.type"
                [pattern]="val.pattern"
                [message]="val.mes"
                [max]="val.max"
                [min]="val.min"
              ></dxi-validation-rule>
            </ng-container>
          </dxi-column>
        </ng-container>
        <ng-container *ngIf="gridCtlList.editMode === 'custom' && batchEditingAllowDeleting && !showBatchEditButton">
          <ng-container *ngIf="item.type === columnType.editButtonColumn">
            <dxi-column
              [dataField]="item.dataField"
              type="buttons"
              [width]="item.width"
              [hidingPriority]="item.hidingPriority"
              [visibleIndex]="item.visibleIndex"
              [fixed]="item.fixed"
              [fixedPosition]="getSafeFixedposition(item.fixedPosition)"
              [allowFiltering]="false"
              [allowSearch]="false"
            >
              <dxi-button
                icon="edit"
                [hint]="'Düzenle'"
                [onClick]="clickEditButtonFunc"
              ></dxi-button>
            </dxi-column>
            <ng-container *ngIf="!inlineMenuActions && gridCtlList.historyEntity">
              <dxi-button
                icon="clock"
                [hint]="'Geçmiş'"
                [onClick]="clickShowHistoryButtonFunc"
              ></dxi-button>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="item.type === columnType.deleteButtonColumn">
            <dxi-column
              [dataField]="item.dataField"
              type="buttons"
              [width]="item.width"
              [hidingPriority]="item.hidingPriority"
              [visibleIndex]="item.visibleIndex"
              [fixed]="item.fixed"
              [fixedPosition]="getSafeFixedposition(item.fixedPosition)"
              [allowFiltering]="false"
              [allowSearch]="false"
            >
              <!-- DKM-2587 Cedric: eski hâli [disabled]="!(formMetaData?.formYetki?.deleteYn && donemAktif)" -->
              <dxi-button
                [disabled]="silPasif(!(formMetaData?.formYetki?.deleteYn && donemAktif))"
                [hint]="'Sil'"
                icon="trash"
                [onClick]="clickDeleteButtonFunc"
              ></dxi-button>
              <ng-container
                *ngIf="!inlineMenuActions && gridCtlList.historyEntity"
              >
                <dxi-button
                  icon="clock"
                  [hint]="'Geçmiş'"
                  [onClick]="clickShowHistoryButtonFunc"
                ></dxi-button>
              </ng-container>
            </dxi-column>
          </ng-container>

          <ng-container *ngIf="item.type === columnType.bothDeleteEditButton">
            <dxi-column
              [dataField]="item.dataField"
              type="buttons"
              [width]="item.width"
              [hidingPriority]="item.hidingPriority"
              [visibleIndex]="item.visibleIndex"
              [fixed]="item.fixed"
              [fixedPosition]="getSafeFixedposition(item.fixedPosition)"
              [allowFiltering]="false"
              [allowSearch]="false"
            >
              <ng-container *ngIf="otherActionBtnList">
                <dxi-button
                  *ngFor="let button of otherActionBtnList"
                  [hint]="button.name"
                  [text]="button.name"
                  [icon]="button.icon"
                  [disabled]="button.disabled"
                  [onClick]="otherActionClicked.bind(this,{button})"
                >
                </dxi-button>
              </ng-container>
              <ng-container *ngIf="gridCtlList.allowUpdatingYn">
                <dxi-button
                  icon="edit"
                  [hint]="'Düzenle'"
                  [disabled]="!formMetaData?.formYetki?.updateYn"
                  [onClick]="clickEditButtonFunc"
                ></dxi-button>
              </ng-container>
              <ng-container *ngIf="gridCtlList.allowDeletingYn">
                <!-- DKM-2587 Cedric: eski hâli [disabled]="!(formMetaData?.formYetki?.deleteYn && donemAktif)" -->
                <dxi-button
                  [disabled]="silPasif(!(formMetaData?.formYetki?.deleteYn && donemAktif))"
                  [hint]="'Sil'"
                  icon="trash"
                  [onClick]="clickDeleteButtonFunc"
                ></dxi-button>
              </ng-container>
              <ng-container *ngIf="inlineMenuActions">
                <dxi-button
                  [id]="'menuButton' + gridIdRandom"
                  [hint]="'İşlemler'"
                  icon="menu"
                  [onClick]="clickmenuButtonFunc"
                ></dxi-button>
              </ng-container>
              <ng-container
                *ngIf="!inlineMenuActions && gridCtlList.historyEntity"
              >
                <dxi-button
                  icon="clock"
                  [hint]="'Geçmiş'"
                  [onClick]="clickShowHistoryButtonFunc"
                ></dxi-button>
              </ng-container>
            </dxi-column>
          </ng-container>

          <ng-container *ngIf="item.type === columnType.TeklifVer">
            <dxi-column
              [dataField]="item.dataField"
              type="buttons"
              [width]="item.width"
              [hidingPriority]="item.hidingPriority"
              [visibleIndex]="item.visibleIndex"
              [fixed]="item.fixed"
              [fixedPosition]="getSafeFixedposition(item.fixedPosition)"
              [allowFiltering]="false"
              [allowSearch]="false"
            >
              <ng-container>
                <dxi-button
                  text="Teklif Ekle"
                  icon="add"
                  [onClick]="clickTeklifVerButtonFunc"
                ></dxi-button>
              </ng-container>
            </dxi-column>
          </ng-container>

          <ng-container *ngIf="item.type === columnType.MuayeneGir">
            <dxi-column
              [dataField]="item.dataField"
              type="buttons"
              [width]="item.width"
              [hidingPriority]="item.hidingPriority"
              [visibleIndex]="item.visibleIndex"
              [fixed]="item.fixed"
              [fixedPosition]="getSafeFixedposition(item.fixedPosition)"
              [allowFiltering]="false"
              [allowSearch]="false"
            >
              <ng-container>
                <dxi-button
                  text="Muayene Bilgisi Ekle"
                  icon="search"
                  [onClick]="clickMuayeneEkleButtonFunc"
                ></dxi-button>
              </ng-container>
            </dxi-column>
          </ng-container>

          <ng-container *ngIf="item.type === columnType.MuayeneDetayGor">
            <dxi-column
              [allowFiltering]="false"
              [allowSearch]="false"
              [dataField]="item.dataField"
              type="buttons"
              [width]="item.width"
              [hidingPriority]="item.hidingPriority"
              [visibleIndex]="item.visibleIndex"
              [fixed]="item.fixed"
              [fixedPosition]="getSafeFixedposition(item.fixedPosition)"
            >
              <ng-container>
                <dxi-button
                  icon="edit"
                  [disabled]="!formMetaData?.formYetki?.updateYn"
                  [onClick]="clickEditButtonFunc"
                ></dxi-button>
                <!-- DKM-2587 Cedric: eski hâli [disabled]="!(formMetaData?.formYetki?.deleteYn && donemAktif)" -->
                <dxi-button
                  icon="trash"
                  [disabled]="silPasif(!(formMetaData?.formYetki?.deleteYn && donemAktif))"
                  [onClick]="clickDeleteButtonFunc"
                ></dxi-button>
                <dxi-button
                  text="Muayene Detayı Gör"
                  icon="info"
                  [onClick]="clickMuayeneDetayGorButtonFunc"
                ></dxi-button>
              </ng-container>
            </dxi-column>
          </ng-container>

          <ng-container *ngIf="item.type === columnType.ColumnWithButton">
            <dxi-column
              [dataField]="item.dataField"
              type="buttons"
              [width]="item.width"
              [hidingPriority]="item.hidingPriority"
              [visibleIndex]="item.visibleIndex"
              [fixed]="item.fixed"
              [fixedPosition]="getSafeFixedposition(item.fixedPosition)"
              [allowFiltering]="false"
              [allowSearch]="false"
            >
              <ng-container *ngIf="otherActionBtnList">
                <dxi-button
                  *ngFor="let button of otherActionBtnList"
                  [hint]="button.name"
                  [text]="button.name"
                  [disabled]="button.disabled"
                  [icon]="button.icon"
                  [onClick]="otherActionClicked.bind(this,{button})"
                >
                </dxi-button>
              </ng-container>
              <ng-container *ngIf="inlineMenuActions">
                <dxi-button
                  [id]="'menuButton' + gridIdRandom"
                  [hint]="'İşlemler'"
                  icon="menu"
                  [onClick]="clickmenuButtonFunc"
                ></dxi-button>
              </ng-container>
              <ng-container
                *ngIf="!inlineMenuActions && gridCtlList.historyEntity"
              >
                <dxi-button
                  icon="clock"
                  [hint]="'Geçmiş'"
                  [onClick]="clickShowHistoryButtonFunc"
                ></dxi-button>
              </ng-container>
            </dxi-column>
          </ng-container>

          <ng-container *ngIf="item.type === columnType.detailButtonColumn">
            <dxi-column
              [dataField]="item.dataField"
              type="buttons"
              [width]="item.width"
              [hidingPriority]="item.hidingPriority"
              [visibleIndex]="item.visibleIndex"
              [fixed]="item.fixed"
              [fixedPosition]="getSafeFixedposition(item.fixedPosition)"
              [allowFiltering]="false"
              [allowSearch]="false"
            >
              <dxi-button
                icon="detailslayout"
                [onClick]="clickDetailButtonFunc"
              ></dxi-button>
            </dxi-column>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="item.type === columnType.addButtonColumn">
          <dxi-column
            [dataField]="item.dataField"
            type="buttons"
            [width]="item.width"
            [hidingPriority]="item.hidingPriority"
            [visibleIndex]="item.visibleIndex"
            [fixed]="item.fixed"
            [fixedPosition]="getSafeFixedposition(item.fixedPosition)"
            [allowFiltering]="false"
            [allowSearch]="false"
          >
            <dxi-button icon="add" [onClick]="clickAddButtonFunc"></dxi-button>
          </dxi-column>
        </ng-container>
      </ng-container>

      <dxo-summary *ngIf="gridCtlList.allowTotalbarYn">
        <ng-container *ngFor="let column of columnList">
          <ng-container *ngIf="column.summaryType && !isTotalFormulaDisable">

            <dxi-total-item
              *ngIf="isMatchWholeWord(column,'sum')"
              [column]="column.dataField"
              [summaryType]="'sum'"
              [valueFormat]="column.format ? currencyFormat : null"
              [displayFormat]="'{0}'"
            >
            </dxi-total-item>
            <dxi-group-item
              *ngIf="isMatchWholeWord(column,'sumg')"
              [column]="column.dataField"
              [summaryType]="'sum'"
              [valueFormat]="column.format ? currencyFormat : null"
              [displayFormat]="'{0}'"
              [showInGroupFooter]="false"
              [alignByColumn]="true"
            >
            </dxi-group-item>
            <dxi-total-item
              *ngIf="isMatchWholeWord(column,'avg')"
              [column]="column.dataField"
              [summaryType]="'avg'"
              [valueFormat]="column.format ? currencyFormat : null"
              [displayFormat]="'O:{0}'"
            >
            </dxi-total-item>
            <dxi-group-item
              *ngIf="isMatchWholeWord(column,'avgg')"
              [column]="column.dataField"
              [summaryType]="'avg'"
              [valueFormat]="column.format ? currencyFormat : null"
              [showInGroupFooter]="false"
              [displayFormat]="'O:{0}'"
              [alignByColumn]="true"
            >
            </dxi-group-item>
            <dxi-total-item
              *ngIf="isMatchWholeWord(column,'min')"
              [column]="column.dataField"
              [summaryType]="'min'"
              [valueFormat]="column.format ? currencyFormat : null"
              [displayFormat]="'Min:{0}'"
            >
            </dxi-total-item>
            <dxi-group-item
              *ngIf="isMatchWholeWord(column,'ming')"
              [column]="column.dataField"
              [summaryType]="'min'"
              [valueFormat]="column.format ? currencyFormat : null"
              [showInGroupFooter]="false"
              [displayFormat]="'Min:{0}'"
              [alignByColumn]="true"
            >
            </dxi-group-item>
            <dxi-total-item
              *ngIf="isMatchWholeWord(column,'max')"
              [column]="column.dataField"
              [summaryType]="'max'"
              [valueFormat]="column.format ? currencyFormat : null"
              [displayFormat]="'Maks:{0}'"
            >
            </dxi-total-item>
            <dxi-group-item
              *ngIf="isMatchWholeWord(column,'maxg')"
              [column]="column.dataField"
              [summaryType]="'max'"
              [valueFormat]="column.format ? currencyFormat : null"
              [showInGroupFooter]="false"
              [displayFormat]="'Maks:{0}'"
              [alignByColumn]="true"
            >
            </dxi-group-item>

          </ng-container>
        </ng-container>
        <dxi-group-item
          [column]="keyExpr ? keyExpr : 'Kod'"
          [summaryType]="'count'"
          [displayFormat]="'{0} Adet'"
        >
        </dxi-group-item>
      </dxo-summary>

      <ng-container *ngIf="otherButtonsData?.length > 0">
        <dxi-column
          [dataField]=""
          type="buttons"
          [allowFiltering]="false"
          [allowSearch]="false"
          [width]="
            otherButtonsData.length === 1 ? 50 : otherButtonsData.length * 30
          "
          [hidingPriority]=""
          [visibleIndex]="99"
          caption="Diğer İşlemler"
          [fixed]=""
        >
          <dxi-button
            *ngIf="otherButtonsData[0]"
            [visible]="isFirstOtherButtonVisible"
            icon="{{ otherButtonsData[0].Icon }}"
            hint="{{ otherButtonsData[0].Tooltip }}"
            [onClick]="clickOtherButtonFuncFirst"
          ></dxi-button>
          <dxi-button
            *ngIf="otherButtonsData[1]"
            [visible]="isSecondOtherButtonVisible"
            icon="{{ otherButtonsData[1].Icon }}"
            hint="{{ otherButtonsData[1].Tooltip }}"
            [onClick]="clickOtherButtonFuncSecond"
          ></dxi-button>
          <dxi-button
            *ngIf="otherButtonsData[2]"
            [visible]="isThirdOtherButtonVisible"
            icon="{{ otherButtonsData[2].Icon }}"
            hint="{{ otherButtonsData[2].Tooltip }}"
            [onClick]="clickOtherButtonFuncThird"
          ></dxi-button>
          <dxi-button
            *ngIf="otherButtonsData[3]"
            [visible]="isFourthOtherButtonVisible"
            icon="{{ otherButtonsData[3].Icon }}"
            hint="{{ otherButtonsData[3].Tooltip }}"
            [onClick]="clickOtherButtonFuncFourth"
          ></dxi-button>
          <dxi-button
            *ngIf="otherButtonsData[4]"
            [visible]="isFifthOtherButtonVisible"
            icon="{{ otherButtonsData[4].Icon }}"
            hint="{{ otherButtonsData[4].Tooltip }}"
            [onClick]="clickOtherButtonFuncFifth"
          ></dxi-button>
        </dxi-column>
      </ng-container>

      <dxo-toolbar *ngIf="showToolbar">
        <dxi-item location="before" *ngIf="tableTittle">
          <div class="grid-toolbar-header">{{ tableTittle }}</div>
        </dxi-item>
        <ng-container *ngIf="dropdownConfig">
          <dxi-item
            location="after"
            widget="dxDropDownButton"
            [options]="{
          stylingMode:dropdownConfig.styLingMode || 'outlined',
          type: dropdownConfig.type || 'default',
          displayExpr:dropdownConfig.displayExpr ||'name',
          keyExpr:dropdownConfig.keyExpr || 'value',
          useSelectMode: true,
          items: dropdownConfig.items,
          selectedItemKey: dropdownConfig.selectedItemKey,
          onSelectionChanged: onDropDownSelectChanged,
          width:150,
          minWidth:100,
          maxWidth:300,

        }">
          </dxi-item>
        </ng-container>
        <ng-container *ngIf="tableHeaderSwitchButton">
          <dxi-item location="after">
            <div *dxTemplate>
              <div class="custom-switch-wrapper">
                <label for="customSwitch" class="switch-label">{{
                    tableHeaderSwitchButton
                  }}</label>
                <dx-switch
                  id="customSwitch"
                  class="custom-switch"
                  [hint]="tableHeaderSwitchButton"
                  [(value)]="batchEditing"
                  (onValueChanged)="switchButtonChanged($event)"
                >
                </dx-switch>
              </div>
            </div>
          </dxi-item>
        </ng-container>
        <ng-container *ngIf="customTableHeaderSwitchButton">
          <dxi-item location="after">
            <div *dxTemplate>
              <div class="custom-switch-wrapper">
                <label for="customSwitch" class="switch-label">{{
                    customTableHeaderSwitchButton
                  }}</label>
                <dx-switch
                  id="customSwitch"
                  class="custom-switch"
                  [hint]="customTableHeaderSwitchButton"
                  [(value)]="customTableHeaderSwitchButtonValue"
                  (onValueChanged)="customHeaderSwitchButtonChanged($event)"
                >
                </dx-switch>
              </div>
            </div>
          </dxi-item>
        </ng-container>
        <ng-container *ngIf="gridCtlList?.allowPivotYn">
          <dxi-item location="after">
            <div *dxTemplate class="custom-switch-wrapper pivot-switch">
              <dx-button class="pivot-button"
                         [text]="'Pivot'"
                         (click)="pivotGridMode = true"
                         [width]="'90px'"
              ></dx-button>

            </div>
          </dxi-item>
        </ng-container>
        <ng-container *ngIf="dynamicTableHeaderButtons">
          <dxi-item location="after" *ngFor="let dynamicButton of dynamicTableHeaderButtons" [locateInMenu]="dynamicButtonsLocateInMenu">
            <div *dxTemplate>
              <dx-button
                [attr.style]="dynamicButton.style"
                [disabled]="dynamicButton.disabled"
                [text]="dynamicButton.text"
                [icon]="dynamicButton.icon"
                [type]="dynamicButton.type"
                [stylingMode]="dynamicButton.stylingMode"
                (click)="handleTableHeaderDynamicButtonClick(dynamicButton)"
              ></dx-button>
            </div>
          </dxi-item>
        </ng-container>
        <dxi-item location="after" *ngIf="tableAddNewButton"
                  [locateInMenu]="'never'"
                  widget="dxButton"
                  [disabled]="tableAddNewButton?.disable || !(formMetaData?.formYetki?.insertYn && donemAktif) || !dataSource"
                  [options]="tableHeaderAddButtonOpt">

        </dxi-item>
        <!-- DKM-5344 Clara: eski hâli — Liste Resetleme / Liste Ayarları düğmeleri araç çubuğundaydı; Tercihler popup'ının altına taşındı.
        <dxi-item location="after" *ngIf="!isListEditAdmin && !hideListSettingsButtons && !dlistSaveOverride"
                  [locateInMenu]="'auto'"
                  widget="dxButton"
                  [options]="gridStateSettingResetButton">

        </dxi-item>
        <dxi-item location="after" *ngIf="!hideListSettingsButtons"
                  [locateInMenu]="'auto'"
                  widget="dxButton"
                  [options]="gridStateSettingButton">

        </dxi-item>
        (DKM-5344 Clara: eski hâli sonu) -->
        <!--        <ng-container *ngIf="gridCtlList?.showSettingYn || gridListCtlNew?.showSettingYn">-->
        <ng-container>
          <dxi-item
            [id]="'showSettingPop' + gridIdRandom"
            widget="dxButton"
            [options]="showSettingPopupOptions"
          >
          </dxi-item>
        </ng-container>
        <dxi-item
          name="addRowButton"
          [locateInMenu]="'never'"
          [visible]="addRow"
          *ngIf="gridCtlList.editMode !== 'form'"
        ></dxi-item>

        <dxi-item
          [locateInMenu]="'never'"
          *ngIf="editingMode === 'batch' && batchEditing"
          widget="dxButton"
          [options]="batchSaveButtonOptions"
        ></dxi-item>

        <dxi-item
          [locateInMenu]="'never'"
          *ngIf="editingMode === 'batch' && batchEditing && gridCtlList.allowAddingYn"
          widget="dxButton"
          [options]="batchAddButtonOptions"
        ></dxi-item>

        <dxi-item
          [locateInMenu]="'auto'"
          widget="dxButton"
          [options]="refreshDataGridButtonOptions"
        >
        </dxi-item>
        <dxi-item
          [locateInMenu]="'auto'"
          widget="dxButton"
          [options]="clearFilterButtonOptions"
        >
        </dxi-item>
        <dxi-item name="columnChooserButton" [locateInMenu]="'auto'"></dxi-item>
        <dxi-item name="groupPanel" [locateInMenu]="'auto'"></dxi-item>
        <dxi-item name="exportButton" [locateInMenu]="'auto'"></dxi-item>
        <dxi-item name="searchPanel"></dxi-item>
      </dxo-toolbar>

      <div *dxTemplate="let cellInfo of 'tmpl_eh'">
        <div [ngClass]="{'green-bg': cellInfo.value === 'E','red-bg':cellInfo.value === 'H'}">
          <div *ngIf="cellInfo.value == 'E'">Evet</div>
          <div *ngIf="cellInfo.value == 'H'">Hayır</div>
        </div>
      </div>

      <div *dxTemplate="let cellInfo of 'tmpl_eh_checkbox'">
        <div style="height:100%;width:100%;display:flex;">
          <dx-check-box class="template-checkbox dx-state-hover"
          [ngClass]="{'green-checkbox':cellInfo.value == 'E','red-checkbox':cellInfo.value == 'H','null-checkbox':cellInfo.value == null}"
          [tabIndex]="-1"
          [focusStateEnabled]="false"
          [activeStateEnabled]="false"
          [hoverStateEnabled]="false"
          [value]="cellInfo.value == null ? null : cellInfo.value === 'E' ? true : false"
          [readOnly]="true"
          ></dx-check-box>
        </div>
      </div>
      <ng-container *ngFor="let templates of cellTemplates">
        <div
          *dxTemplate="
            let itemData of templates.field;
            let itemIndex = index
          "
        >
          <ng-template
            [ngTemplateOutlet]="templates.template"
            [ngTemplateOutletContext]="{
              itemData: itemData,
              itemIndex: itemIndex
            }"
          >
          </ng-template>
        </div>
      </ng-container>

      <ng-container *ngFor="let templates of editCellTemplates">
        <div
          *dxTemplate="
            let itemData of templates.field;
            let itemIndex = index
          "
        >
          <ng-template
            [ngTemplateOutlet]="templates.template"
            [ngTemplateOutletContext]="{
              itemData: itemData,
              itemIndex: itemIndex
            }"
          >
          </ng-template>
        </div>
      </ng-container>

    </dx-data-grid>

    <dk-gen-pivot-grid *ngIf="pivotGridMode && gridCtlList?.allowPivotYn"
                       class="pivot-grid"
                       [pivotGridMode]="pivotGridMode"
                       (pivotGridModeChange)="pivotGridMode = $event"
                       [gridCtlList]="gridCtlList"
                       [gridDataSource]="dataSource"
                       [pivotLoadUrl]="pivotLoadUrl"
    ></dk-gen-pivot-grid>


    <ng-container *ngIf="bakiyeDisplay">
      <div style="text-align: right; margin-top: 3px; font-weight: bold; border-radius: 5px">
        <ng-content select=".dxgrid-bottom"></ng-content>
      </div>
    </ng-container>
    <ng-container *ngIf="bottomDynamicButtons">
      <dk-grid-bottom-toolbar [dynamicButtons]="bottomDynamicButtons" [chevron]="displayBottomChevron"
                              (chevronButtonClicked)="chevronButtonClicked($event)"
                              (dynamicButtonClicked)="handleBottomDynamicButons($event)"></dk-grid-bottom-toolbar>
    </ng-container>

    <ng-container *ngIf="inlineMenuActions">
      <dx-action-sheet
        [items]="inlineMenuActions"
        [width]="'auto'"
        [showTitle]="false"
        [showCancelButton]="false"
        [usePopover]="true"
        [(visible)]="actionSheetVisible"
        [target]="actionSheetTarget"
        (onItemClick)="clickMenuButtonActions($event)"
        itemTemplate="link"
      >
        <div *dxTemplate="let item of 'link'">
          <div class="item-template-container link" [ngClass]="{ 'disabled': item.disabled}">
            <span
              class="dx-icon-{{ item.icon }}"
              style="margin-right: 4px"
            ></span>
            <span class="dx-menu-item-text">{{ item.name }}</span>
          </div>
        </div>
      </dx-action-sheet>
    </ng-container>

    <ng-container *ngIf="rightClickActions">
      <dx-context-menu
        [dataSource]="rightClickActions"
        [width]="200"
        [target]="'#' + gridIdRandom + ' .dx-row-focused'"
        (onItemClick)="contextMenu($event)"
      >
      </dx-context-menu>
    </ng-container>
  </div>
</div>

<!-- DKM-5155 Cedric: eski hâli (Tercihler popup'ı; yeni hâli aşağıda)
<ng-container *ngIf="showAttributes">
  <dx-popup
    [width]="200"
    [height]="'auto'"
    [shading]="true"
    [showCloseButton]="false"
    [hideOnOutsideClick]="true"
    shadingColor="rgba(0, 0, 0, 0.5)"
    [title]="'Tercihler'"
    [(visible)]="showAttributes"
    (onHidden)="onTercihPopupHidden()"
    [position]="{ my: 'top', at: 'bottom', of: showTarget }"
  >
    <div class="options p-2" *ngIf="gridListCtlNew">
      <dx-button
        [ngClass]="'modules-btn'"
        icon="close"
        (click)="closedPopover()"
        [text]="'Kapat'"
      ></dx-button>
      <div class="option" *ngIf="gridListCtlNew?.showFilterYn">
        <div class="dx-field-value">
          <dx-check-box
            text="Filitreleme Alanı"
            [(value)]="gridListCtlNew.allowFilterYn"
            (onValueChanged)="clearFilter()"
          ></dx-check-box>
        </div>
      </div>
      <ng-container *ngIf="!this.baseTable">
        <div class="option pl-2" *ngIf="gridListCtlNew?.showGroupingYn">
          <div class="dx-field-value">
            <dx-check-box
              text="Gruplama Alanı"
              [(value)]="gridListCtlNew.allowGroupingYn"
              (onValueChanged)="clearFilter()"
            ></dx-check-box>
          </div>
        </div>
        <div class="option pl-2" *ngIf="gridListCtlNew.showActioncolumnYn">
          <div class="dx-field-value">
            <dx-check-box
              text="Kolon Seçimleri"
              [(value)]="gridListCtlNew.columnChooserYn"
              (onValueChanged)="clearFilter()"
            ></dx-check-box>
          </div>
        </div>
        <div class="option pl-2" *ngIf="gridListCtlNew?.allowSelectionYn">
          <div class="dx-field-value">
            <dx-check-box
              text="Seçim Kolonu"
              [(value)]="gridListCtlNew.showSelectionYn"
              (onValueChanged)="clearFilter()"
            ></dx-check-box>
          </div>
        </div>
        <div class="option pl-2" *ngIf="gridListCtlNew.showTotalbarYn">
          <div class="dx-field-value">
            <dx-check-box
              text="Toplam Satırı"
              [(value)]="gridListCtlNew.allowTotalbarYn"
              (onValueChanged)="clearFilter()"
            ></dx-check-box>
          </div>
        </div>
        <div class="option pl-2" *ngIf="gridListCtlNew.showSearchYn">
          <div class="dx-field-value">
            <dx-check-box
              text="Arama Kutusu"
              [(value)]="gridListCtlNew.allowSearchYn"
              (onValueChanged)="clearFilter()"
            ></dx-check-box>
          </div>
        </div>
      </ng-container>
    </div>
    <p style="margin: 0; padding: 0" *ngIf="!isListEditAdmin">{{ gridCtlList.dlistCode }}</p>
    <div style="display: flex; align-items: center;justify-content: space-between" *ngIf="isListEditAdmin">
      <span>{{ gridCtlList.dlistCode }}</span>
      <span style="margin-left: 6px;">
        <dx-button
          icon="rowproperties"
          stylingMode="text"
          type="default"
          hint="Grid Ayarları"
          (onClick)="openGridSettingsPopup(gridCtlList.dlistCode)"
          ></dx-button>
      </span>
    </div>
-->

    <!--  <dxo-position-->
    <!--    my="top"-->
    <!--    at="bottom"-->
    <!--    [of]="showTarget"-->
    <!--  ></dxo-position>-->
<!--  </dx-popup>
</ng-container>
(DKM-5155 Cedric: eski hâli sonu) -->
<!-- DKM-5155 Cedric: Tercihler popup'ı ikonlu/anahtarlı (switch) yeni tasarım; bağlamalar aynı -->
<ng-container *ngIf="showAttributes">
  <!-- DKM-5344 Clara: eski hâli [width]="260" — alttaki açıklamalı Kaydet/Resetle satırları için 290 -->
  <dx-popup
    [width]="290"
    [height]="'auto'"
    [shading]="true"
    [showTitle]="false"
    [showCloseButton]="false"
    [hideOnOutsideClick]="true"
    shadingColor="rgba(0, 0, 0, 0.5)"
    [wrapperAttr]="{ class: 'dk-tercih-popup' }"
    [(visible)]="showAttributes"
    (onHidden)="onTercihPopupHidden()"
    [position]="{ my: 'top', at: 'bottom', of: showTarget }"
  >
    <div class="dk-tercih-baslik">
      <i class="dx-icon dx-icon-preferences dk-tercih-baslik-ikon"></i>
      <div class="dk-tercih-baslik-metin">
        <span>Tercihler</span>
      </div>
      <dx-button
        class="dk-tercih-kapat"
        icon="close"
        stylingMode="text"
        hint="Kapat"
        (onClick)="closedPopover()"
      ></dx-button>
    </div>
    <div class="dk-tercih-liste" *ngIf="gridListCtlNew">
      <ng-container *ngIf="!this.baseTable">
        <div class="dk-tercih-satir" *ngIf="gridListCtlNew.showSearchYn">
          <i class="dx-icon dx-icon-search dk-tercih-ikon"></i>
          <span class="dk-tercih-metin">Arama Kutusu</span>
          <dx-switch
            [(value)]="gridListCtlNew.allowSearchYn"
            (onValueChanged)="clearFilter()"
          ></dx-switch>
        </div>
        <div class="dk-tercih-satir" *ngIf="gridListCtlNew.showTotalbarYn">
          <i class="dx-icon dx-icon-formula dk-tercih-ikon"></i>
          <span class="dk-tercih-metin">Toplam Satırı</span>
          <dx-switch
            [(value)]="gridListCtlNew.allowTotalbarYn"
            (onValueChanged)="clearFilter()"
          ></dx-switch>
        </div>
        <div class="dk-tercih-satir" *ngIf="gridListCtlNew?.allowSelectionYn">
          <i class="dx-icon dx-icon-selectall dk-tercih-ikon"></i>
          <span class="dk-tercih-metin">Seçim Kolonu</span>
          <dx-switch
            [(value)]="gridListCtlNew.showSelectionYn"
            (onValueChanged)="clearFilter()"
          ></dx-switch>
        </div>
        <div class="dk-tercih-satir" *ngIf="gridListCtlNew.showActioncolumnYn">
          <i class="dx-icon dx-icon-columnchooser dk-tercih-ikon"></i>
          <span class="dk-tercih-metin">Kolon Seçimleri</span>
          <dx-switch
            [(value)]="gridListCtlNew.columnChooserYn"
            (onValueChanged)="clearFilter()"
          ></dx-switch>
        </div>
        <div class="dk-tercih-satir" *ngIf="gridListCtlNew.showGroupingYn">
          <i class="dx-icon dx-icon-group dk-tercih-ikon"></i>
          <span class="dk-tercih-metin">Gruplama Alanı</span>
          <dx-switch
            [(value)]="gridListCtlNew.allowGroupingYn"
            (onValueChanged)="clearFilter()"
          ></dx-switch>
        </div>
      </ng-container>
      <div class="dk-tercih-satir" *ngIf="gridListCtlNew.showFilterYn">
        <i class="dx-icon dx-icon-filter dk-tercih-ikon"></i>
        <span class="dk-tercih-metin">Filtreleme Alanı</span>
        <dx-switch
          [(value)]="gridListCtlNew.allowFilterYn"
          (onValueChanged)="clearFilter()"
        ></dx-switch>
      </div>
    </div>
    <!-- DKM-5344 Clara: Liste ayarlarını kaydet / resetle — araç çubuğundan buraya, açıklamalı (koşullar eskisiyle aynı) -->
    <div class="dk-tercih-islem" *ngIf="!hideListSettingsButtons">
      <button type="button" class="dk-tercih-islem-btn"
              [ngClass]="'dk-tercih-rol-' + (userListEditRole || 'kullanici')"
              [title]="gridStateSettingButton.hint"
              (click)="tercihListeAyarKaydet()">
        <i class="dx-icon dx-icon-rowproperties dk-tercih-ikon"></i>
        <span class="dk-tercih-islem-metin">
          <span class="dk-tercih-islem-ad">Liste Ayarlarını Kaydet</span>
          <small>{{ listeAyarKaydetAciklama }}</small>
        </span>
      </button>
      <button type="button" class="dk-tercih-islem-btn dk-tercih-islem-reset"
              *ngIf="!isListEditAdmin && !hideListSettingsButtons && !dlistSaveOverride"
              title="Liste Resetleme"
              (click)="tercihListeAyarResetle()">
        <i class="dx-icon dx-icon-clearsquare dk-tercih-ikon"></i>
        <span class="dk-tercih-islem-metin">
          <span class="dk-tercih-islem-ad">Liste Ayarlarını Resetle</span>
          <small>{{ listeAyarResetAciklama }}</small>
        </span>
      </button>
    </div>
    <div class="dk-tercih-alt">
      <span class="dk-tercih-kod" *ngIf="!isListEditAdmin">{{ gridCtlList.dlistCode }}</span>
      <ng-container *ngIf="isListEditAdmin">
        <span class="dk-tercih-kod">{{ gridCtlList.dlistCode }}</span>
        <dx-button
          icon="rowproperties"
          stylingMode="text"
          type="default"
          hint="Grid Ayarları"
          (onClick)="openGridSettingsPopup(gridCtlList.dlistCode)"
        ></dx-button>
      </ng-container>
    </div>
  </dx-popup>
</ng-container>

<ng-container *ngIf="historyPopupVisible">
  <dx-popup
    height="82%"
    width="80%"
    [showTitle]="true"
    [position]="'center'"
    [title]="'İşlem Geçmişi'"
    [resizeEnabled]="true"
    [hideOnOutsideClick]="false"
    [showCloseButton]="true"
    [(visible)]="historyPopupVisible"
    (onHidden)="onHistoryPopupHidden()"
  >
    <dk-history
      [entityName]="this.historyFilterData.kayitAdi"
      [selectedRowData]="historyFilterData"
    ></dk-history>
  </dx-popup>
</ng-container>

<!-- DkDxDataCtlTableComponent Template -->
<ng-container *ngIf="gridSettingsPageVisible">
  <dx-popup
    [height]="'96%'"
    [width]="'80%'"
    [position]="'center'"
    [title]="gridCtlList?.dlistCode + ' Liste Ayarları'"
    [resizeEnabled]="true"
    [hideOnOutsideClick]="false"
    [showCloseButton]="true"
    [visible]="true"
    (onHidden)="onGridSettingPopupHidden()"
  >
    <dx-scroll-view width="100%" height="100%" style="margin-bottom: 5px">
      <div #gridSettingsContainer></div>
    </dx-scroll-view>
  </dx-popup>
</ng-container>

<dx-popup
  [(visible)]="editCaptionPopupVisible"
  [width]="400"
  [height]="220"
  title="Başlığı Düzenle"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
>
  <div
    style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 24px; gap: 16px;">
    <dx-text-box
      [(value)]="captionEditText"
      [showClearButton]="true"
      placeholder="Yeni başlığı girin"
      stylingMode="outlined"
      style="width: 100%; max-width: 400px;"
    ></dx-text-box>

    <div style="display: flex; gap: 8px; width: 100%; max-width: 400px;">
      <dx-button
        text="İptal"
        icon="close"
        type="danger"
        stylingMode="outlined"
        (onClick)="cancelCaptionEdit()"
      ></dx-button>

      <dx-button
        text="Kaydet"
        type="default"
        icon="save"
        stylingMode="contained"
        [disabled]="!captionEditText"
        (onClick)="applyCaptionChange()"
      ></dx-button>
    </div>
  </div>
</dx-popup>
